// Library Dependencies
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ErrorHandler, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

// State Objects
import { reducers, effects } from './store';

// Shared Modules
import { ErrorHandlerModule } from '@shared/error-handler-notify/error-handler.module';
import { ReportHistoryModule } from './report-history/report-history.module';
import { CommonUXModule } from './shared/common-ux/common-ux.module';

// Components
import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { HelpComponent } from './help/help.component';
import { NotificationsComponent } from './notifications/notifications.component';
import { NotificationVerificationComponent } from './notification-verification/notification-verification.component';
import { ViewAttachmentComponent } from './view-attachment/view-attachment.component';
import { MaintenanceComponent } from './maintenance/maintenance.component';
import { PingAuthenticationModule } from '@aa-techops-ui/ping-authentication';

import { environment } from '../environments/environment';
import { MatExpansionModule } from '@angular/material/expansion';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ToDoModule } from './to-do/to-do.module';
import { OfflineSyncComponent } from './offline-sync/offline-sync.component';
import { AppRoutingModule } from './app-routing';
import { GlobalErrorHandler } from '@shared/error-handler-notify/services';

// Pipes
import { PhoneNotificationPipe } from './notifications/phone.pipe';
import { DatePipe } from '@angular/common';

@NgModule({
    declarations: [
        AppComponent,
        HomeComponent,
        HelpComponent,
        OfflineSyncComponent,
        NotificationsComponent,
        NotificationVerificationComponent,
        ViewAttachmentComponent,
        PhoneNotificationPipe,
        MaintenanceComponent,
    ],
    bootstrap: [AppComponent],
    imports: [
        PingAuthenticationModule.forRoot({
            authority: environment.authority,
            client_id: environment.clientId,
            idle_threshold: environment.idle_threshold,
            timeout_duration: environment.timeout_duration,
            use_html5_routing: environment.use_html5_routing,
            load_user_info: environment.load_user_info,
            log_level: environment.logLevel,
            scope: environment.scope,
            post_logout_redirect_uri: `${window.location.origin}/signout-callback`,
        }),
        StoreModule.forRoot(reducers, {
            runtimeChecks: {
                strictStateImmutability: false,
                strictActionImmutability: false,
                strictStateSerializability: false,
                strictActionSerializability: false,
                strictActionWithinNgZone: false,
                strictActionTypeUniqueness: false,
            },
        }),
        EffectsModule.forRoot(effects),
        environment.production ? [] : StoreDevtoolsModule.instrument({ connectInZone: true }),
        AppRoutingModule,
        BrowserModule,
        BrowserAnimationsModule,
        FormsModule,
        ReactiveFormsModule,
        ReportHistoryModule,
        ToDoModule,
        ErrorHandlerModule,
        MatExpansionModule,
        CommonUXModule
    ],
    providers: [
        DatePipe,
        { provide: ErrorHandler, useClass: GlobalErrorHandler },
        provideHttpClient(withInterceptorsFromDi())
    ]
})
export class AppModule {
}
